import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "menu-nav" }
const _hoisted_2 = { class: "user-name" }
const _hoisted_3 = {
  key: 0,
  class: "fa-solid fa-chevron-down dashboard-user-chevron"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-tie" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-shield" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right-from-bracket" }, null, -1)

import { ref, onMounted, watch, computed } from "vue";

import store from "@/store/index";
import { useRouter } from "vue-router";
import { useCookies } from "vue3-cookies";
import { USER, USER_LOGINED } from "@/const/cookie";
import commons from "@/utils/Common";
import { CHANGE_PASSWORD, INFORM, SIGN_IN } from '@/const/path'

export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfor',
  props: {
    variant: { default: "default" }
  },
  setup(__props: any) {


const { cookies } = useCookies();
const router = useRouter();
const name = ref("");
const url = ref("");
const logOut = async () => {
  commons.logOut();
  router.push({ path: SIGN_IN });
};
const inform = async () => {
  router.push({ path: INFORM });
};
const urlAvatar = computed(() => {
  return store.getters.isUrlAvatar;
});
const changePassword = async () => {
  router.push({ path: CHANGE_PASSWORD });
};
onMounted(() => {
  let user = cookies.get(USER);
  if (user != null && user != undefined) {
    name.value = user.name;
    url.value = user.urlAvatar;
  }
});

watch(urlAvatar, (newValue, oldValue) => {
  url.value = JSON.parse(JSON.stringify(newValue));
});

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_dropdown, null, {
      overlay: _withCtx(() => [
        _createVNode(_component_a_menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { onClick: inform }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('text.userInformation')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { onClick: changePassword }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('text.changePass')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { onClick: logOut }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('text.logOut')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", {
          class: "user-dropdown-link",
          onClick: inform
        }, [
          _createVNode(_component_a_avatar, {
            size: "small",
            src: url.value
          }, null, 8, ["src"]),
          _createElementVNode("a", _hoisted_2, _toDisplayString(name.value), 1),
          (_ctx.variant === 'dashboard')
            ? (_openBlock(), _createElementBlock("i", _hoisted_3))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})